export enum AssignmentObjectEvents {
  INVALID_DATE = '@assignmentObjectEvent/INVALID_DATE',
}
